import ls from 'local-storage';

export const loginConst = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    CLEAR: 'CLEAR_LOGIN' 
};

const initialState = { payload: null }; 

const LoginReducer = (state = initialState, action) => {
    switch (action.type) {
        case loginConst.SUCCESS:
            return {
                login: 'login-success',
                payload: action.payload
            };
        case loginConst.ERROR:
            return {
                login: 'login-fail',
                payload: action.payload
            };
        case loginConst.CLEAR:
            return {
                login: null,
                payload: null
            };
        default:
            return state
    }
}

export const clearLogin = () => ({
    type: loginConst.CLEAR
});

export default LoginReducer;